import { Swiper } from '@services';
import { M as Mousewheel } from './mousewheel-DQ8bUi4_.js';
import './utils-W20TaRiR.js';

class CollectionNavigation extends HTMLElement {
  swiper = this.querySelector('.swiper');

  connectedCallback() {
    this.initSwiper();
  }

  initSwiper() {
    new Swiper(this.swiper, {
      modules: [Mousewheel],
      slidesPerView: 'auto',
      slidesOffsetAfter: -24,
      mousewheel: {
        enabled: true,
        releaseOnEdges: true,
      },
    });
  }
}

customElements.define('collection-navigation', CollectionNavigation);
